/**
 * Centralized environment detection utility
 */

export type Environment = 'production' | 'development';
export type EnvironmentTier = 'production' | 'sandbox';

/**
 * Detects the current environment based on hostname
 */
export function getEnvironment(): Environment {
  const hostname = window.location.hostname;
  const isProduction = !hostname.includes('sandbox') &&
                       !hostname.includes('localhost') &&
                       !hostname.includes('127.0.0.1');
  return isProduction ? 'production' : 'development';
}

/**
 * Detects the environment tier (for Paddle and other services)
 */
export function getEnvironmentTier(): EnvironmentTier {
  const hostname = window.location.hostname;
  // Treat localhost, 127.0.0.1, and any URL with 'sandbox' as sandbox environment
  const isSandbox = hostname.includes('sandbox') ||
                    hostname.includes('localhost') ||
                    hostname.includes('127.0.0.1');
  return isSandbox ? 'sandbox' : 'production';
}

/**
 * Check if we're in production environment
 */
export function isProduction(): boolean {
  return getEnvironment() === 'production';
}

/**
 * Check if we're in development/sandbox environment
 */
export function isDevelopment(): boolean {
  return getEnvironment() === 'development';
}

/**
 * Check if we're in local development
 */
export function isLocalhost(): boolean {
  const hostname = window.location.hostname;
  return hostname.includes('localhost') || hostname.includes('127.0.0.1');
}

// Export for debugging
if (typeof window !== 'undefined') {
  (window as any).envUtils = {
    getEnvironment,
    getEnvironmentTier,
    isProduction,
    isDevelopment,
    isLocalhost,
    current: getEnvironment()
  };
}